<template>

<Spinner style="margin-top: 150px;" v-if="!LoadNbCable"/>

<van-list
v-if="LoadNbCable"
  :finished="LoadNbCable"
  class="cursor_card m-t2 m-l-4"
>

<van-cell class="cell_card_number style_card all_border_radius"  v-for="item in NbFibre" :key="item.pk_nb_fibre" clickable @click="chooseNbFibre(item.pk_nb_fibre, item.nb_fibre)" >
  
  <van-row class="row_card">
  <van-col  class="d-content "  span="2">

    <span v-if="item.nb_fibre == StoreNbFibre" style="color:#1989fa">{{ item.nb_fibre }}</span>
    <span v-else>{{ item.nb_fibre }}</span>

  </van-col>

  <van-col class="d-content " span="2">
    <van-icon v-if="item.nb_fibre == StoreNbFibre" class="icon_check_choice" name="success" color="#1989fa" style="vertical-align: top" size="20" />

  </van-col>

</van-row>

</van-cell>

</van-list>


<span v-if="!messageNbFibre && LoadNbCable" style="margin: 8px 13px;display: block;">
<!-- <van-icon  @click="this.messageNbFibre = true" class="icon_info" color="#1989fa"  name="info-o" size="2rem" /> -->
</span>

<span class="van-notice-bar all_border_radius" v-if="messageNbFibre" style="padding: 10px;background:#ecf9ff;color:#1989fa;margin: 10px 13px;height: auto;">
 <van-icon  style="margin-left: 0px; margin-right: 20px;" class="icon_info" color="#1989fa"  name="info-o" size="2rem" /> 
  <span class="text-info-number" style="padding: 6px;">
    {{ $t('infoNbFibre1') }} <br>
    {{ $t('infoNbFibre2') }}
  </span>



</span>

    </template>
    
    
    <script>
    import Spinner from '../../../loader/Spinner.vue'
    export default {
      props: ['messageNbFibre'],
      emits :{
        'update-msg-nbfibre': null,
        },
      components: {
        Spinner,
      },
      data() {
        return {
          LoadNbCable: false,
        }
      },
      created() {
    this.getNbFibre();
  
    },
    computed: {
        /** Nombre de fibre */
        StoreNbFibre() { 
          return this.globalFunction.existKeyInArray("nombre", this.$store.state.storeCable.cable) 
          ? this.$store.state.storeCable.cable.nombre.nbFibre
          : null 
            },
          },
    methods: {
      async getNbFibre() {
        try {
          //Appel de l'api + transofrmation Json'
          const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/preco_nb_fibres?etat=true',{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": this.$store.state.storeGlobal.StoreJwtToken
    },
    })
          
          var resultApi = (await res.json());
          this.NbFibre = resultApi;
      
          //etat environnement tru ou false
          this.etatEnv = resultApi;
          //etat chargement de la page
          this.LoadNbCable = true;
        } catch (error) {
          this.answer = 'Error! Could not reach the API. ' + error
        }
      },
      chooseNbFibre(pkNbFibre, nbFibre){
        this.$emit('update-msg-nbfibre', false)

       // this.$emit('majMsgNbFibre', this.refPanier)
        this.obj = {
          'cable' : {
            'nombre' : {
            nbFibre:nbFibre,
        pkNbFibre: pkNbFibre
      }
         
    }};

    //this.messageNbFibre = false
        this.$store.commit('SET_CHOICE_CABLE', this.obj )

      }
    },
    
    
    }
    </script>